/* Predictive search placeholder */
(function() {
  'use strict';

  if (!window.Shopify || !window.Shopify.designMode) {
    return;
  }
})();
